import { useRequest } from 'ahooks';
import { useFlagConfigValue } from './system/useFlagConfig';
import { useOrgValue } from './system/useOrg';
import { useOrgConfigStateValue } from './useOrgConfig';
import { syncMessage } from 'services/api/conversation.convList';
import getNeedSyncIds from './conversationNeedSync';
import { useConversationSummaryList } from './conversation';

export const isInSyncTalkRange = (
  conversation: Conversation.ConversationSummary,
  startTime: number,
  hours: number = 6,
) => {
  const timeLimit = hours * 3600 * 1000;
  const { lastMsgTime, talkId } = conversation;
  return !!talkId && startTime - Number(lastMsgTime) < timeLimit;
};

const getSyncTalkIdsFromConversations = (
  conversations: Conversation.ConversationSummary[],
  syncChannel: Conversation.ConversationSummary['channel'],
  hours: number = 6,
) => {
  const talkIds: string[] = [];
  const d = Date.now();
  conversations.forEach((conversation) => {
    const { channel, talkId } = conversation;
    if (syncChannel === channel && isInSyncTalkRange(conversation, d, hours)) {
      talkIds.push(talkId);
    }
  });
  return talkIds;
};

export const useBootSyncTalkIds = () => {
  const orgValue = useOrgValue();
  const isNewOrg = orgValue?.isNewOrg;
  const { newOrgSyncMessageIntervalSeconds } = useFlagConfigValue();
  const { mercadoSyncMessageSeconds } = useOrgConfigStateValue();
  const conversationSummaryList = useConversationSummaryList();

  const syncIntervalSeconds = isNewOrg ? newOrgSyncMessageIntervalSeconds : 120;

  /**
   * shopee 同步会话
   * 筛选出6 小时内的会话进行同步
   */
  useRequest(
    async () => {
      const syncTalkIds = getSyncTalkIdsFromConversations(conversationSummaryList, 'SHOPEE');
      if (syncTalkIds.length > 0) {
        const talkIds = getNeedSyncIds(syncTalkIds, syncIntervalSeconds);
        if (talkIds.length > 0) {
          return syncMessage({ talkIds });
        }
      }
      return Promise.resolve();
    },
    {
      pollingInterval: syncIntervalSeconds * 1000,
    },
  );

  /**
   * mercado 同步会话
   * mercadoSyncMessageSeconds 白名单用户开启
   * 筛选出16 小时内的会话进行同步
   */
  useRequest(
    async () => {
      const syncTalkIds = getSyncTalkIdsFromConversations(conversationSummaryList, 'MERCADO', 16);
      if (syncTalkIds.length > 0) {
        const talkIds = getNeedSyncIds(syncTalkIds, mercadoSyncMessageSeconds);
        if (talkIds.length > 0) {
          return syncMessage({ talkIds });
        }
      }
      return Promise.resolve();
    },
    {
      pollingInterval: mercadoSyncMessageSeconds ? mercadoSyncMessageSeconds * 1000 : undefined,
    },
  );
};
